// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1649142632820
      var cssReload = require("E:/3x1010/Projects-2021/dev.virtualqueens.net/VisualStudio/Web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  